import gql from 'graphql-tag';
import {priceDetailsFragments} from '@homeaway/react-price-details';

const priceDetailsContainerFragments = {
    CheckoutExperienceModel: gql`
        fragment PriceDetailsContainerCheckoutExperienceModel on CheckoutExperienceModel {
            priceDetails {
                averageNightlies {
                    perNightCost {
                        currency
                        amount
                        localized
                    }
                    type
                }
                checkoutUrl
                dueNow {
                    title
                    amount
                    tooltips {
                        title
                        amount
                        tooltip
                    }
                }
                edapPriceQuotePresented
                edapQuoteSuccess
                instantBooking
                lineItems {
                    title
                    mixedCurrencyDisclaimer
                }
                notes {
                    description
                }
                payments {
                    viewUrl
                }
                totalNumeric {
                    totalInCents
                }
                ...PriceDetailsPriceDetails
            }
        }
        ${priceDetailsFragments.PriceDetails}
    `
};

export {priceDetailsContainerFragments};
